import { Injectable } from '@angular/core';
import { RouteIds, Step } from '../../types';
import { GoogleAnalyticsEventEnum } from '../../google-analytics';
import { StepDefinitionStrategy } from './step-definition.strategy';

/**
 * Step definition service for the Your Information step
 */
@Injectable({
  providedIn: 'root',
})
export class YourInformationStepDefinitionService implements StepDefinitionStrategy {
  getStepDefinition(): Step {
    return {
      id: RouteIds.yourInformation,
      title: $localize`2. Your Information`,
      subtitle: $localize`Just a few more details to secure your place`,
      nextStep: () => RouteIds.confirmation,
      previousStep: () => RouteIds.buildYourCourse,
      googleAnalyticsEvent: GoogleAnalyticsEventEnum.YourInformation,
    };
  }
}
